var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mastercard-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2163 14.2893H17.7863V1.70801H10.2148V14.2867L10.2163 14.2893Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6968 8C10.6954 6.78864 10.9922 5.59288 11.5647 4.50324C12.1371 3.4136 12.9702 2.45864 14.0008 1.71067C12.7243 0.782948 11.1913 0.205982 9.57685 0.0457241C7.96246 -0.114534 6.33186 0.148381 4.87144 0.804417C3.41103 1.46045 2.17973 2.48314 1.31828 3.75558C0.456832 5.02802 0 6.49887 0 8C0 9.50113 0.456832 10.972 1.31828 12.2444C2.17973 13.5169 3.41103 14.5395 4.87144 15.1956C6.33186 15.8516 7.96246 16.1145 9.57685 15.9543C11.1913 15.794 12.7243 15.2171 14.0008 14.2893C12.9702 13.5413 12.1372 12.5863 11.5648 11.4967C10.9924 10.4071 10.6955 9.21134 10.6968 8Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0017 8.0002C28.001 9.50073 27.5438 10.9708 26.6824 12.2426C25.821 13.5143 24.5901 14.5365 23.1303 15.1923C21.6704 15.848 20.0405 16.111 18.4267 15.9511C16.813 15.7913 15.2803 15.215 14.0039 14.2882C15.0336 13.5396 15.8661 12.5846 16.4385 11.4953C17.0109 10.4059 17.3083 9.21063 17.3083 7.99953C17.3083 6.78844 17.0109 5.59315 16.4385 4.5038C15.8661 3.41445 15.0336 2.45947 14.0039 1.71087C15.2802 0.783502 16.8129 0.206792 18.4269 0.0466501C20.0409 -0.113492 21.671 0.149394 23.1311 0.805264C24.5911 1.46113 25.8221 2.48353 26.6834 3.7556C27.5447 5.02768 28.0015 6.49812 28.0017 7.99887V8.0002Z",
    fill: "#F79E1B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.11e3c3167a6ed4f0fbb01a5dc1e4dc40.svg";
export { ForwardRef as ReactComponent };